import { Component, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { IBasePlan, MobilePlanItem, PlansConfigurationService } from '@ztarmobile/zwp-service-backend';
import { FadeInOutAnimation } from 'src/app/app.animations';
import { Options } from 'ng5-slider';
import { take } from 'rxjs'
import { Router } from '@angular/router';
import { SHOP_ROUTE_URLS, PLANS_SHOP_ROUTE_URLS, ROUTE_URLS } from 'src/app/app.routes.names';

@Component({
  selector: 'app-featured-plans',
  templateUrl: './featured-plans.component.html',
  styleUrls: ['./featured-plans.component.scss'],
  animations: [FadeInOutAnimation]
})
export class FeaturedPlansComponent implements OnInit {
  public featuredPlans: IBasePlan[];
  public responsiveFeaturedPlans: IBasePlan[];
  public innerWidth: any;
  public plans: Array<MobilePlanItem>;
  public value: any;
  public options: Options;
  public planPrices = [];
  public selectedPrice: number;
  public ROUTE_URLS = ROUTE_URLS;
  public istemporarily = false;

  private allBasePlans: Array<IBasePlan>;

  constructor(private plansConfigurationService: PlansConfigurationService, private router: Router,
    private cd: ChangeDetectorRef) {
    const acpStopDate = new Date("February 7, 2024").getTime();
    const todaysDate = new Date().getTime();
    this.istemporarily = (acpStopDate >= todaysDate);
  }

  ngOnInit(): void {
    this.innerWidth = document.documentElement.clientWidth;
    this.plansConfigurationService.planConfiguration.pipe(take(1)).subscribe((conf) => {
      this.allBasePlans = conf.allPlans;
      this.featuredPlans = this.allBasePlans.filter((plan) => plan.featured && !plan.archived && !plan.ebb);
      this.responsiveFeaturedPlans = this.allBasePlans.filter((plan) => !!plan.parentId && !plan.archived);
      this.checkSpecialPromotionPrices(this.featuredPlans);
      this.featuredPlans.map(plan => {
        const priceExists = this.planPrices.some((price) => plan.price === price);
        if (!priceExists) {
          this.planPrices.push(plan.price)
        }
      });
      this.selectedPrice = this.planPrices[0];
    });
  }

  public priceSelected(item): void {
    this.selectedPrice = item;
  }

  public viewAllPlans(planPrice?: any) {
    if (!!planPrice) {
      const params = {};
      params[PLANS_SHOP_ROUTE_URLS.PARAMS.PRICE] = planPrice;
      this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.PLANS_AND_FEATURES}/${PLANS_SHOP_ROUTE_URLS.NEW_PLAN}`, params]);
    } else {
      this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.PLANS_AND_FEATURES}/${PLANS_SHOP_ROUTE_URLS.NEW_PLAN}`]);
    }
  }

  private checkSpecialPromotionPrices(arr: IBasePlan[]): void {
    arr.forEach(plan => {
      if (!!plan.specialPromotion && !!plan.specialPromotion.promotionDiscount) {
        const discountAmountValue = plan.specialPromotion.promotionDiscount.split('%')[0];
        const discountValue = parseInt(discountAmountValue, 10);
        const total = (plan.price - plan.promoPrice) * (discountValue / 100);
        plan.priceAfterSpecialPromoDiscount = total;
      }
      else {
        plan.priceAfterSpecialPromoDiscount = plan.price - plan.promoPrice;
      }
    })
    arr.sort((a, b) => a.price - b.price);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = document.documentElement.clientWidth;
  }
}

